/**
 * Post-deploy stale-chunk recovery. Port of apps/web/src/lib/stale-chunk.ts.
 *
 * After a Q deploy, an open tab (or a navigation racing the deploy) can ask for
 * a chunk hash the new build no longer serves. functions/assets now answers
 * that with a real 404, so the dynamic import REJECTS; this turns the rejection
 * into ONE reload against the fresh shell. The sessionStorage guard stops a
 * reload loop if the reload itself cannot fix it.
 */

const SIGNATURES = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  "Unexpected token '<'",
  'Expected a JavaScript-or-Wasm module script',
  'Unable to preload CSS',
  'ChunkLoadError',
];

export function isStaleChunkError(err: unknown): boolean {
  if (err == null) return false;
  if (typeof err === 'string') return SIGNATURES.some((s) => err.includes(s));
  const e = err as { message?: unknown; name?: unknown };
  const haystack = `${String(e.name ?? '')} ${String(e.message ?? err)}`;
  return SIGNATURES.some((s) => haystack.includes(s));
}

const KEY = 'postopia.q.staleChunkReloadAt';

/** Reload once; returns false when a reload in the last 10 s did not help. */
export function recoverFromStaleChunk(reason: string): boolean {
  const now = Date.now();
  let last = 0;
  try {
    last = Number(sessionStorage.getItem(KEY) || '0');
  } catch {
    /* storage disabled: proceed without the guard */
  }
  if (last && now - last < 10_000) {
    console.error('[stale-chunk] reload did not resolve:', reason);
    return false;
  }
  try {
    sessionStorage.setItem(KEY, String(now));
  } catch {
    /* ignore */
  }
  window.location.reload();
  return true;
}
